import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-679925d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tasks-container" }
const _hoisted_2 = { class: "tasks-container__toolbar" }
const _hoisted_3 = {
  key: 0,
  class: "tasks-container__loading"
}
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center"
}

import { computed, ref, watch } from 'vue';
import { debounce } from 'lodash';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

import Task from '@/components/TaskCard.vue';
import TasksTable from '@/components/tasks/TasksTable.vue';
import { TableSkeleton } from '@/design-system/Skeleton';

import DSTextField from '@/design-system/DSTextField.vue';
import DSEmptyState from '@/design-system/DSEmptyState.vue';
import DSButton from '@/design-system/DSButton.vue';

import { useStore } from '@/store';
import { FETCH_TASKS } from '@/store/types/actions';

import {
  isGridLayout,
  updateTaskLayout,
  GRID_LAYOUT,
  CARD_LAYOUT,
} from '@/hooks/layout';


export default /*#__PURE__*/_defineComponent({
  __name: 'TasksContainer',
  setup(__props) {

const $q = useQuasar();
const store = useStore();
const task_filter = ref('');
const is_grid_layout = ref(isGridLayout());
const request_pending = computed(() => store.state.requests_pending.tasks?.fetch_user_tasks);

watch(task_filter, debounce(function () {
  store.dispatch(FETCH_TASKS, task_filter.value);
}, 700));

store.dispatch(FETCH_TASKS);

const tasks = computed(() => store.state.task.tasks);

const getIsGridLayout = computed(() => {
  return is_grid_layout.value && $q.screen.gt.xs;
});

const updateLayout = () => {
  if (isGridLayout()) {
    updateTaskLayout(CARD_LAYOUT);
    is_grid_layout.value = false;
  } else {
    updateTaskLayout(GRID_LAYOUT);
    is_grid_layout.value = true;
  }
};

const scrollToForm = () => {
  const formElement = document.querySelector('.task-form');
  if (formElement) {
    formElement.scrollIntoView({ behavior: 'smooth' });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DSTextField, {
        modelValue: task_filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((task_filter).value = $event)),
        placeholder: "Search tasks...",
        icon: "search",
        dense: "",
        class: "tasks-container__search",
        "aria-label": "Search tasks"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        flat: "",
        round: "",
        dense: "",
        icon: is_grid_layout.value ? 'view_list' : 'view_module',
        onClick: updateLayout,
        "aria-label": is_grid_layout.value ? 'Switch to list view' : 'Switch to grid view',
        class: "tasks-container__view-toggle"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(is_grid_layout.value ? 'List view' : 'Grid view'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["icon", "aria-label"])
    ]),
    (request_pending.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (getIsGridLayout.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                return _createVNode(_unref(TableSkeleton), { key: n })
              }), 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_spinner_gears, {
                  color: "primary",
                  size: "3rem"
                })
              ]))
        ]))
      : (! tasks.value.length)
        ? (_openBlock(), _createBlock(DSEmptyState, {
            key: 1,
            title: "No tasks found",
            message: "Start by creating your first task and track your progress!",
            icon: "task_alt"
          }, {
            default: _withCtx(() => [
              _createVNode(DSButton, {
                label: "Create Task",
                icon: "add",
                variant: "primary",
                onClick: scrollToForm
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["tasks-container__content", {
        'tasks-container__content--cards': ! getIsGridLayout.value,
        'tasks-container__content--table': getIsGridLayout.value,
      }])
          }, [
            (! getIsGridLayout.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(tasks.value, (task) => {
                  return (_openBlock(), _createBlock(Task, {
                    key: task.id,
                    task: task,
                    "is-grid-layout": getIsGridLayout.value
                  }, null, 8, ["task", "is-grid-layout"]))
                }), 128))
              : (_openBlock(), _createBlock(TasksTable, { key: 1 }))
          ], 2))
  ]))
}
}

})